import { Dictionary, values } from 'lodash'
import { ModifierOptionContract } from 'models'
import { EntityModifierViewModel, ItemViewModel } from 'store/models/sellModels'
export function getOptionModifiers(
    opt: ModifierOptionContract,
    itemsMap: Dictionary<ItemViewModel>,
    modifierList: EntityModifierViewModel[],
) {
    let modifierOptionModifiers: EntityModifierViewModel[] =
        modifierList.filter(
            (a) => a.isActive && a.entityId === opt.modifierOptionID,
        )
    // if 'Item' type modifier option
    // please note that `opt.itemID` can be both "product ID" (if the modifier option is simple product) or variant product
    if (opt.itemID) {
        // use `itemsMap` to check if item type of this modifier option is variant item
        let item: ItemViewModel | undefined = itemsMap[opt.itemID]
        if (!itemsMap[opt.itemID]) {
            // try adding modifier(s) that applied on its base item (if has)
            item = values(itemsMap)
                .flatMap((i) => i.variations)
                .find((vi) => vi.itemId === opt.itemID)

            // add baseItem's ID to the candidate list
        }
        if (item) {
            modifierOptionModifiers = [
                ...modifierOptionModifiers,
                ...getItemModifiers(item, modifierList),
            ]
        }
    }
    return modifierOptionModifiers
}

export function hasItemModifierAssigned(
    item: ItemViewModel,
    modifierList: EntityModifierViewModel[],
) {
    const entityIds: string[] = [
        item.baseItemId ?? '', // itemModifiers
        item.itemId ?? '', // itemModifiers
        ...item.combinationIds, //variantOptionModifiers
    ]

    return modifierList.some(
        (m) => m.isActive && entityIds.includes(m.entityId),
    )
}
export function getItemModifiers(
    item: ItemViewModel,
    modifierList: EntityModifierViewModel[],
) {
    const excludeModifierIDs = item.overrideCategoryModifierSettings
        .filter((a) => !a.isActive)
        .map((a) => a.itemCategoryModifierID)

    const entityIds: string[] = [
        item.categoryId ?? '', // itemCategoryModifiers
        item.baseItemId ?? '', // itemModifiers
        item.itemId ?? '', // itemModifiers
        ...item.combinationIds, //variantOptionModifiers
    ]

    return modifierList.filter(
        (m) =>
            m.isActive &&
            entityIds.includes(m.entityId) &&
            !excludeModifierIDs.includes(m.entityModifierId),
    )
}
